module.exports = length;

/**
 * Calculates the length of a vec3
 *
 * @param {vec3} a vector to calculate length of
 * @returns {Number} length of a
 */
function length(a) {
    var x = a[0],
        y = a[1],
        z = a[2]
    return Math.sqrt(x*x + y*y + z*z)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/gl-vec3/length.js
// module id = 369
// module chunks = 0